<template>
  <b-container>
    <b-col class="mt-2">
      <div>
        <b-row class="form-group">
        <b-col offset="4" md="8" align="right">
          <b-button class="clear" @click="clearFilterData()">
            {{ $t("label_advancedData_clearFilters") }}
          </b-button>
          <b-button variant="primary" @click="setComparativeDataFromPromise()">
            {{ $t("label_advancedData_applyFilters") }}
          </b-button>
        </b-col>
      </b-row>
        <template-filters ref="filters" />
        <b-container v-if="!getIsLoading">
          <b-row>
            <b-col cols="12" lg="12" md="12">
              <template-pillar-navigator-consolidated
                :pillar-id="currentPillarIdConsolidated"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="12" md="12">
              <template-indicator-navigator-consolidated
                :pillar-id="currentPillarIdConsolidated"
                :indicator-id="currentIndicatorIdConsolidated"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6">
              <card-indicator-info-consolidated
                :pillar-id="currentPillarIdConsolidated"
                :indicator-id="currentIndicatorIdConsolidated"
                :height="'400px'"
              />
            </b-col>
            <b-col cols="12" lg="6">
              <card-chart-gauge-consolidated
                :pillar-id="currentPillarIdConsolidated"
                :indicator-id="currentIndicatorIdConsolidated"
                :alias="'gauge' + currentIndicatorIdConsolidated"
                :height="'400px'"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="12">
              <!--        <card-charts-indicator-consolidated :pillar-id="currentPillarIdConsolidated" :indicator-id="currentIndicatorIdConsolidated" :alias="'chart' + currentIndicatorIdConsolidated" height="500px"></card-charts-indicator-consolidated>-->
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="12">
              <card-conventions
                orientation="horizontal"
                :show-ideal="false"
                :show-company="false"
              />
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-col>
  </b-container>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ReportsPillarConsolidatedIndicator",
  components: {},
  data: function () {
    return {
      gauge: [],
      indicatorsData: [],
      currentIndicator: {},
      paramsPillar: "",
    };
  },
  computed: {
    ...mapGetters([
      "currentPillarIdConsolidated",
      "currentIndicatorIdConsolidated",
      "getIsLoading",
    ]),
  },
  methods: {
    clearFilterData() {
      if (this.$refs.filters) {
        this.$refs.filters.clearFilters();
      }
      this.getConsolidatedData();
    },
    getConsolidatedData() {
      let parameters = {
        Companies: [],
        Tags: [],
        Years: [],
        Types: [],
        Locations: [],
        Sizes: [],
        Activities: [],
      };
      if (this.$refs.filters) {
        parameters = this.$refs.filters.getDataInFilters();
      }
      this.$store
        .dispatch("CONSOLIDATE_PILLARS_REPORT", parameters)
        .then(() => {
          this.setCurrentPillarIdConsolidated(this.$route.params.pillar);
          this.setCurrentIndicatorIdConsolidated(this.$route.params.indicator);
        })
        .catch((err) => {
          console.log(err);
          //  this.$router.push('/home') // TODO Handle the error in a better way
        });
    },
    ...mapMutations([
      "setCurrentPillarIdConsolidated",
      "setCurrentIndicatorIdConsolidated",
    ]),
  },
  watch: {
    $route() {
      this.setCurrentPillarIdConsolidated(this.$route.params.pillar);
      this.setCurrentIndicatorIdConsolidated(this.$route.params.indicator);
    },
  },
  mounted() {
    this.getConsolidatedData();
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-size: 1.5rem;
  margin-top: 40px;
}
#ChartPillarContainer {
  text-align: center;
}
.col-5,
.col-7 {
  padding-right: 5px;
  padding-left: 5px;
}
.col-8,
.left {
  padding-right: 5px;
}
.col-4,
.right {
  padding-left: 5px;
}
.clear {
  margin-right: 5px;
}
</style>
